var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-card-comingSoon is-flex is-flex-direction-row"},[_c('div',{staticClass:"cardComingSoon"},[_c('div',{staticClass:"card-content-ComingSoon"},[_c('p',{staticClass:"textComingSoon"},[_vm._v(_vm._s(_vm.message))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }